var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoU(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 123,
    viewBox: "0 0 98 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.1039 35.7417C93.9585 36.5059 92.7876 37.2317 91.6168 37.954C93.314 37.8005 94.0801 38.6519 96.4108 37.9924C96.0099 39.2451 95.6948 40.3024 95.3369 41.3421C93.1885 47.8011 90.9868 54.2529 88.8493 60.7295C88.7222 61.1876 88.502 61.6166 88.2021 61.9908C87.9022 62.3647 87.5279 62.676 87.1021 62.9066C85.0936 64.0164 83.1422 65.2132 81.1729 66.3962C83.1743 66.6335 85.4694 66.9858 87.034 66.8988C85.2438 71.0476 83.7937 74.987 81.8998 78.7139C80.4928 81.4632 78.5485 83.9477 76.7942 86.5195C76.0782 87.5664 75.0039 87.9465 73.6794 87.7687C72.3545 87.5908 71.0515 87.6223 69.7411 87.5593C69.7161 87.6711 69.6946 87.7864 69.666 87.9084C71.2697 88.4456 72.8633 88.9898 74.485 89.5412C70.8294 97.5424 52.7739 110.739 43.7479 111.288C44.3854 109.522 50.06 97.5912 50.708 95.8329C58.9428 73.5564 68.1264 51.7125 80.124 31.045C80.013 30.9333 79.8984 30.8287 79.7658 30.724C79.408 31.0101 78.9102 31.2194 78.692 31.5928C76.1857 35.7801 73.5433 39.9395 71.2341 44.2524C64.6965 56.4654 59.3867 69.2121 54.1344 81.9902C52.4372 86.1217 50.7259 90.246 49.0002 94.3637C46.5514 100.28 44.076 106.185 41.5748 112.079C41.059 113.299 40.546 114.515 40.0352 115.729C39.1042 117.917 37.887 119.99 36.8128 122.118C36.6553 122.425 36.4548 122.708 36.2579 122.998L36.1219 122.827C37.2389 119.216 38.3583 115.611 39.4803 112.01C17.0387 110.774 0 96.9911 0 70.388V10.1435H25.2234V70.5312C25.2234 82.4683 31.2777 89.3739 43.2251 89.3739C43.4226 89.3865 43.6189 89.4133 43.8125 89.4542C43.7851 89.3637 43.7491 89.2763 43.7049 89.1925C42.495 86.6903 41.2452 84.2059 39.9887 81.7249C39.7345 81.2228 39.3798 80.7796 38.9145 80.0535C41.0082 80.8328 42.8063 82.2184 44.0666 84.0244C44.1863 83.6108 44.2782 83.1901 44.3423 82.7651C44.8222 73.8634 46.7161 65.2305 49.6267 56.8074C55.8816 38.6833 65.1618 22.1889 77.7144 7.48804C79.2512 5.69539 80.957 4.04699 82.809 2.56448C85.8562 0.121903 88.9604 0.565054 91.216 3.67761C96.5864 11.11 98.6234 19.3799 97.4385 28.3861C97.1636 30.3364 96.7713 32.2694 96.2641 34.175C96.0706 34.8101 95.6615 35.3624 95.1039 35.7417Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -35.3628,
    y1: -21.2263,
    x2: 259.863,
    y2: 243.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FC4C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FA6D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F98828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F89D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8AC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7B432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B733"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoU);
export default __webpack_public_path__ + "static/media/LogoU.a4bc15fe7e5fa53e66c0afe887abb003.svg";
export { ForwardRef as ReactComponent };